import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Globle } from 'src/assets/globle';
import { Category } from '../../category/category.model';
import { CategoryService } from '../../category/category.service';
import { SubCategory } from '../subCategory.model';
import { SubcategoryService } from '../subcategory.service';
//import { angularEditorConfig } from '@kolkov/angular-editor/lib/config';
import { AngularEditorConfig } from '@kolkov/angular-editor';

declare var $: any;

@Component({
  selector: 'app-addsubcategory',
  templateUrl: './addsubcategory.component.html',
  styleUrls: ['./addsubcategory.component.css']
})
export class AddsubcategoryComponent implements OnInit, AfterViewInit {

  //#region variables
  category: Category = {} as Category;
  Categories: Category[] = [];
  subCategory: SubCategory = {} as SubCategory;
  updateMode = false;
  imagPath: any;
  files = [];
  active = true;
  spinnerOverlay = false;
  filteredOptions!: Observable<Category[]>;
  searchCategory = new FormControl();
  _submit = false;
  language!: number;
  directCharge = false;

  //#endregion

  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: '500px',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter text here...',
  //   defaultParagraphSeparator: '',
  //   defaultFontName: '',
  //   defaultFontSize: '',
  //   fonts: [
  //     { class: 'arial', name: 'Arial' },
  //     { class: 'times-new-roman', name: 'Times New Roman' },
  //     { class: 'calibri', name: 'Calibri' },
  //     { class: 'comic-sans-ms', name: 'Comic Sans MS' }
  //   ],
  //   customClasses: [
  //     {
  //       name: 'quote',
  //       class: 'quote',
  //     },
  //     {
  //       name: 'redText',
  //       class: 'redText'
  //     },
  //     {
  //       name: 'titleText',
  //       class: 'titleText',
  //       tag: 'h1',
  //     },
  //   ],

  //   //uploadWithCredentials: false,
  //   sanitize: true,
  //   toolbarPosition: 'top',
  //   toolbarHiddenButtons: [
  //     ['bold', 'italic'],
  //     ['fontSize']
  //   ]
  // };

  config = {
    placeholder: 'aaaaa',
    tabsize: 2,
    height: 200,
    dialogsInBody: true,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']],
      ['insert', ['table', 'picture', 'link', 'video', 'hr']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times']
  }

  constructor(private router: Router,
    private categoryService: CategoryService,
    private service: SubcategoryService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.language = this.localStorage.retrieve("lang");
    this.getCategory();
    this.getUrlParam();
  }

  ngAfterViewInit(): void {
    this.loaddropify();

  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(1, this.directCharge).subscribe(data => {
      this.Categories = !this.updateMode ? data.filter(x => x.pytic == 0) : data;
      this.autoCompleatFilter();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.Categories.slice())
      );
  }

  private _filter(name: string): Category[] {
    const filterValue = name.toLowerCase();

    return this.Categories.filter(option => option.arabicName.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(category: Category): string {
    return category && category.arabicName ? category.arabicName : '';
  }

  loaddropify() {
    var drEvent = $('.dropify').dropify();

    drEvent.on('dropify.afterClear', () => {
      this.subCategory.imgUrl = ""
    });

  }

  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.subCategory.id = +param.get("id")!;
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.service.getById(this.subCategory.id).subscribe(data => {
      this.subCategory = data
      if (this.subCategory.bytic == 1) {
        this.searchCategory.disable()

      }
      this.searchCategory.setValue(data["category"]);
      this.subCategory.status == 1 ? this.active = true : this.active = false;
      this.fillDropifyImage(this.imagPath + this.subCategory.imgUrl);
    })
  }

  back() {
    this.router.navigate(["./master/cards/subcategory"]);
  }

  submit() {

    this.spinnerOverlay = true;
    this.active ? this.subCategory.status = 1 : this.subCategory.status = 0;
    if (this.files.length > 0) {
      this.uploadImage();
    }
    else {
      !this.updateMode ? this.create() : this.update();
    }
  }

  create() {

    this.service.Create(this.subCategory).subscribe(data => {
      this.spinnerOverlay = false;
      this._submit = true;
      this.openSnackBar(this.translate.instant("createdSuccessfully"), 'snackBarSuccess');
      //this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }

        this.spinnerOverlay = false;
      })
  }

  update() {

    this.service.Update(this.subCategory).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  onSelectImage(files: any) {
    this.files = files.target.files;
  }

  uploadImage() {

    let fileToUpload = <File>this.files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    this.service.upload(formData).subscribe(data => {

      this.subCategory.imgUrl = data['dbPath'];

      !this.updateMode ? this.create() : this.update();
    }, error => {
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
      this.spinnerOverlay = false;
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  fillDropifyImage(imgUrl: any) {
    var drEvent = $('.dropify').dropify(
      {
        defaultFile: imgUrl
      });
    drEvent = drEvent.data('dropify');
    drEvent.resetPreview();
    //drEvent.clearElement();
    drEvent.settings.defaultFile = imgUrl;
    drEvent.destroy();
    drEvent.init();
  }

  selectCatChange(value: any) {
    this.subCategory.categoryId = value.id;
  }

  addNew() {
    this.subCategory.arabicName = "";
    this.subCategory.englishName = "";
    this.subCategory.cardsHowToUse = "";
    this.fillDropifyImage(null);
    this._submit = false;
  }

}
